import { ManyTag } from '@/components/_SiteWide/CellTemplates/ManyTag'
import { Horizontal, BBDTag, Vertical, Texto } from '@gravitate-js/excalibrr'
import { Popover } from 'antd'
import { startCase } from 'lodash'

type RatebookCellRendererProps = {
  value: {
    counterparty_id: string
    name: string
    id: string
    type: string
    book_type: string
  }[]
}

export function RatebookCellRenderer({ value }: RatebookCellRendererProps) {
  return (
    <Horizontal style={{ flexWrap: 'wrap' }} gap={4}>
      <Popover
        trigger='hover'
        content={
          value.length > 2 ? (
            <Vertical gap={8}>
              <Texto weight={'bold'}>All linked accessorials</Texto>
              <Horizontal gap={4} style={{ flexWrap: 'wrap' }}>
                {value?.map((item) => (
                  <BBDTag style={{ flex: 'none', margin: 0 }} theme2 key={item.counterparty_id}>
                    {item.counterparty_name} - {item.name} ({startCase(item.type)})
                  </BBDTag>
                ))}
              </Horizontal>
            </Vertical>
          ) : null
        }
      >
        {/* dont @ me on this its the only way i can get the popover to work */}
        <div style={{ display: 'inline-block' }}>
          <ManyTag
            tagItems={value.map((item) => `${item.counterparty_name} - ${item.name} (${startCase(item.type)})`)}
            showTooltip={false}
            maxCount={2}
            theme2
          />
        </div>
      </Popover>
    </Horizontal>
  )
}
